import type { ICustomMessageService } from '@metaos/hub-sdk';
import { logUsage } from 'owa-analytics';
import { processBizChatMessage } from './processBizChatMessage';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Creates a BizChat message service for processing messages sent by BizChat when OWA is hosting BizChat.
 * @param targetWindow The window to which messages should be sent
 * @returns An object implementing the ICustomMessageService interface.
 *
 * This is used to receive messages from BizChat when OWA hosts BizChat.
 * This is used by owa-sidepane-bizchat and owa-app-host-components, in MetaOsAppHostContainerWrapper.
 * For example, messages sent from 1JS' scc-core-calendar-surface->useCalendarSurface using sendMessageToMetaOsParent are received here.
 */
export function createBizChatMessageService(
    mailboxInfo: MailboxInfo,
    targetWindow: Window,
    isImmersiveBizchat?: boolean
): ICustomMessageService {
    logUsage('BizChatMessaging_MessageServiceCreatedAsHost', mailboxInfo);
    return {
        tryProcessMessage: function hostHandler(message, postMessage) {
            logUsage('BizChatMessaging_MessageReceivedAsHost', mailboxInfo, { func: message.func });
            return processBizChatMessage(
                mailboxInfo,
                message,
                postMessage,
                targetWindow,
                isImmersiveBizchat
            );
        },
    };
}
